<template>
    <CFormGroup :label="noLabel ? '' : 'Súhlas s marketingovou komunikáciou'">
        <CFormCheckbox :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
            {{ message }}
            <NuxtLink class="link" target="_blank" :to="{ name: 'ochrana-sukromia' }">{{ linkText }}</NuxtLink>
            <CTooltip>
                {{ tooltip }}
            </CTooltip>
        </CFormCheckbox>
    </CFormGroup>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { Agreement } from '#shared/types/Agreement'

const props = withDefaults(
    defineProps<{
        modelValue?: boolean
        agreement: Agreement
        noLabel?: boolean
        lang?: string
    }>(),
    {
        lang: 'sk'
    }
)

const emit = defineEmits<{
    'update:modelValue': [value: boolean]
}>()

const { t: $t, t } = useI18n()
const keyPrefix = 'jobView.sendJobModal.fields.marketingConsent'

const message = computed((): string => {
    return t(`${keyPrefix}.wording`, props.lang) as string
})

const linkText = computed((): string => {
    return String(t(`${keyPrefix}.linkText`, props.lang))
})

const tooltip = computed((): string => {
    return String(t(`${keyPrefix}.tooltip`, props.lang))
})
</script>
